__turbopack_context__.v({
  "billingPeriod": "PrimaryCTA-module__-krn2W__billingPeriod",
  "buttons": "PrimaryCTA-module__-krn2W__buttons",
  "ctaAction": "PrimaryCTA-module__-krn2W__ctaAction",
  "ctaActionMessage": "PrimaryCTA-module__-krn2W__ctaActionMessage",
  "ctaMessage": "PrimaryCTA-module__-krn2W__ctaMessage",
  "price": "PrimaryCTA-module__-krn2W__price",
  "priceDetails": "PrimaryCTA-module__-krn2W__priceDetails",
  "priceRow": "PrimaryCTA-module__-krn2W__priceRow",
  "primaryCTA": "PrimaryCTA-module__-krn2W__primaryCTA",
  "tuitionLabel": "PrimaryCTA-module__-krn2W__tuitionLabel",
  "tuitionPlaceholder": "PrimaryCTA-module__-krn2W__tuitionPlaceholder",
  "tuitionSubLabel": "PrimaryCTA-module__-krn2W__tuitionSubLabel",
});
